import { Link, navigate } from "gatsby";
import React, { Component, createRef } from "react";
import {
  getCategories,
  getManufacturers,
  getTopManufacturers,
  getRegions,
  getCount,
  logOut,
} from "../actions/memberAction";
import CommonHeader from "./common/commonHeader";
import Logo from "./common/logo";
import MobileDropdown from "./dropdownMobile";
import MobileDropdown1 from "./dropDownMobileMain";
import LoadingBar from "react-top-loading-bar";

//css
import * as styles from "../include/css/css-components/header/Header.module.css";

import ChatIcon from "./common/chatIcon";

class Header extends Component {
  ref = createRef(null);
  dropDownRef = createRef(null);
  state = {
    dropDown: false,
    upcomingDropDown: false,
    upcomingDropDownMobile: false,
    regionDropDown: false,
    type: "",
    upcomingBidDropDown: {},
    notifications: [],
    modal: false,
    facets: {},
    showSearch: false,
    showMobileDropdown: false,
    showDashboardSidebarMobile: false,
    allManufacturers: [],
    queryData: "",
    data: {},
    showMobileFilter: false,
    showMobileFilter1: false,
    isCartEmpty: false,
    dashboardCount: {},
  };

  toggleDashboardSidebarModal = () => {
    this.setState({
      showDashboardSidebarMobile: !this.state.showDashboardSidebarMobile,
    });
  };

  detectClickoutside = (e) => {
    if (
      this.state.showSearch &&
      this.dropDownRef.current &&
      !this.dropDownRef.current.contains(e.target)
    ) {
      this.setState({ showSearch: false });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      this.state.showSearch &&
      this.state.showSearch !== prevState.showSearch
    ) {
      document.addEventListener("click", this.detectClickoutside);
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("click", this.detectClickoutside);
  };

  toggleModal = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };
  toggleMobileDropdownModal = (e) => {
    if (e) e.preventDefault();
    this.setState({
      showMobileDropdown: !this.state.showMobileDropdown,
    });
  };

  toggleMobileFilter = (e) => {
    if (e) e.preventDefault();
    this.setState({ showMobileFilter: !this.state.showMobileFilter });
  };

  toggleMobileFilter1 = (e) => {
    if (e) e.preventDefault();
    this.setState({ showMobileFilter1: !this.state.showMobileFilter1 });
  };

  componentDidMount() {
    if (typeof window !== "undefined" && localStorage.getItem("member")) {
      getCount((res) => {
        if (res && res.status == 200) {
          this.setState({ dashboardCount: res.data });
        }
      });
    }

    const a = { ...this.state.data };
    getCategories((res) => {
      if (res && res.status === 200) {
        a.allCategoryListHome = res.data;
      }
    });

    getRegions((res) => {
      if (res && res.status === 200) {
        a.allRegionsHome = res.data;
      }
    });

    getTopManufacturers((res) => {
      if (res && res.status === 200) {
        a.Manufacturer = res.data;
        this.setState({ allManufacturers: res.data });
      }
    });

    getManufacturers((res) => {
      if (res && res.status === 200) {
        a.allTopManufacturer = res.data;
        this.setState({ allManufacturers: res.data });
      }
    });

    this.setState({ data: a });
  }
  toggleUpcomingDropDown = () => {
    this.setState({
      upcomingDropDown: !this.state.upcomingDropDown,
      showSearch: false,
    });
  };
  toggleUpcomingDropDownMobile = () => {
    this.setState({
      upcomingDropDownMobile: !this.state.upcomingDropDownMobile,
    });
  };
  hideDropdown = () =>
    this.setState({ dropDown: false, regionDropDown: false });

  toggleDropdown = (e, type) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    e.preventDefault();
    if (type === this.state.type) {
      this.setState({
        dropDown: !this.state.dropDown,
        type,
        regionDropDown: false,
      });
    } else {
      this.setState({ dropDown: true, type, regionDropDown: false });
    }
  };

  toggleDropdownRegion = (e) => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    e.preventDefault();
    this.setState({
      dropDown: false,
      regionDropDown: !this.state.regionDropDown,
    });
  };

  onLogOut = () => {
    this.ref?.current?.continuousStart();
    logOut((res) => {
      if (res && res.status == 200) {
        this.ref?.current?.complete();
        if (typeof window !== "undefined") {
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("member");
          window.localStorage.removeItem("buyerInspectionClosed");
          window.localStorage.removeItem("buyerInspectionDate");
          window.localStorage.removeItem("mimictoken");
          window.localStorage.removeItem("mimicmember");
          window.location.href =
            process.env.GATSBY_AVIATION_REDIRECT_URL + `members/login`;
        }
      } else {
        this.ref?.current?.complete();
        if (typeof window !== "undefined") {
          window.localStorage.removeItem("token");
          window.localStorage.removeItem("member");
          window.localStorage.removeItem("buyerInspectionClosed");
          window.localStorage.removeItem("buyerInspectionDate");
          window.localStorage.removeItem("mimictoken");
          window.localStorage.removeItem("mimicmember");
          window.location.href =
            process.env.GATSBY_AVIATION_REDIRECT_URL + `members/login`;
        }
      }
    });
  };

  render() {
    const urlLocation = typeof window !== "undefined" && window?.location?.href;

    return (
      <React.Fragment>
        <LoadingBar color="#47ad1d" ref={this.ref} />
        <header id="header">
          <CommonHeader
            toggleModal={this.toggleModal}
            isCartEmpty={this.state.isCartEmpty}
            dashboardCount={this.state.dashboardCount}
          />
          <div
            className={`${styles.headerMainContainer} header-main-container`}
          >
            <nav
              className={`${styles.navbar} navbar navbar-expand-xl ${styles.navbarExpandXl}`}
            >
              <div className="container-fluid">
                <div
                  className={`${styles.navInside} nav-inside position-relative flex-wrap d-flex align-items-center`}
                >
                  <Logo />
                  <button
                    className={`${styles.navIcon} nav-icon`}
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#categoriesCollapse"
                    onClick={this.toggleMobileFilter}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                  <div
                    className={` navbar-collapse flex-grow-0 d-none d-md-block`}
                  >
                    <div
                      className={`${styles.navbarInside} navbar-inside ml-auto`}
                    >
                      <ul
                        className={`${styles.navbarNav} navbar-nav flex-md-row`}
                      >
                        <li className={`${styles.navItem} nav-item`}>
                          <a
                            // target="_blank"
                            className={`${styles.navLink} nav-link`}
                            href={
                              process.env.GATSBY_AVIATION_REDIRECT_URL +
                              "categories"
                            }
                            // onClick={(e) => {
                            //   e.preventDefault();
                            //   this.toggleDropdown(e, "allCategories");
                            // }}
                          >
                            Categories
                            {/* <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.5 7.25L7 10.75L10.5 7.25" strokeLinecap="round" strokeLinejoin="round" />
                            </svg> */}
                          </a>
                        </li>
                        <li className={`${styles.navItem} nav-item`}>
                          <a
                            className={`${styles.navLink} nav-link`}
                            // target="_blank"
                            href={
                              process.env.GATSBY_AVIATION_REDIRECT_URL +
                              "manufacturers"
                            }
                            // onClick={(e) => {
                            //   e.preventDefault();
                            //   this.toggleDropdown(e, "allManufacturers");
                            // }}
                          >
                            Manufacturers
                            {/* <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.5 7.25L7 10.75L10.5 7.25" strokeLinecap="round" strokeLinejoin="round" />
                            </svg> */}
                          </a>
                        </li>
                        <li className={`${styles.navItem} nav-item`}>
                          <a
                            // onClick={(e) => {
                            //   e.preventDefault();
                            //   this.toggleDropdownRegion(e);
                            // }}
                            className={`${styles.navLink} nav-link`}
                            href={
                              process.env.GATSBY_AVIATION_REDIRECT_URL +
                              "regions"
                            }
                            // target="_blank"
                          >
                            Regions
                            {/* <svg
                              width="14"
                              height="14"
                              viewBox="0 0 14 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path d="M3.5 7.25L7 10.75L10.5 7.25" strokeLinecap="round" strokeLinejoin="round" />
                            </svg> */}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <ul
                    className={`${styles.headerNavList} header-nav-list ms-auto d-flex align-items-center d-xl-none`}
                  >
                    {typeof window !== "undefined" && (
                      <>
                        {" "}
                        {window.localStorage.getItem("token") ? (
                          <>
                            {localStorage.getItem("member") &&
                              JSON.parse(localStorage.getItem("member"))
                                .sec_list != 100103 && (
                                <>
                                  {window.location.pathname === "/chats" ||
                                  window.location.pathname === "/chats/" ? (
                                    <li class={`${styles.htcNavItem}`}>
                                      <a
                                        href={
                                          process.env
                                            .GATSBY_AVIATION_REDIRECT_URL +
                                          "chats"
                                        }
                                        class={`${styles.htcNavLink} htc-nav-link`}
                                      >
                                        <svg
                                          viewBox="0 0 20 20"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M17.5 9.58336C17.5029 10.6832 17.2459 11.7683 16.75 12.75C16.162 13.9265 15.2581 14.916 14.1395 15.6078C13.021 16.2995 11.7319 16.6662 10.4167 16.6667C9.31678 16.6696 8.23176 16.4126 7.25 15.9167L2.5 17.5L4.08333 12.75C3.58744 11.7683 3.33047 10.6832 3.33333 9.58336C3.33384 8.26815 3.70051 6.97907 4.39227 5.86048C5.08402 4.7419 6.07355 3.838 7.25 3.25002C8.23176 2.75413 9.31678 2.49716 10.4167 2.50002H10.8333C12.5703 2.59585 14.2109 3.32899 15.4409 4.55907C16.671 5.78915 17.4042 7.42973 17.5 9.16669V9.58336Z"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </svg>
                                      </a>
                                    </li>
                                  ) : (
                                    <ChatIcon isMobile={true} />
                                  )}
                                </>
                              )}
                            <li class="htc-nav-item ">
                              {
                                <a
                                  href={
                                    process.env.GATSBY_AVIATION_REDIRECT_URL +
                                    "my-account/cart"
                                  }
                                  class="htc-nav-link add-to-cart"
                                >
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_5571_58128)">
                                      <path
                                        d="M7.50001 18.3334C7.96024 18.3334 8.33334 17.9603 8.33334 17.5C8.33334 17.0398 7.96024 16.6667 7.50001 16.6667C7.03977 16.6667 6.66667 17.0398 6.66667 17.5C6.66667 17.9603 7.03977 18.3334 7.50001 18.3334Z"
                                        stroke="black"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M16.6667 18.3334C17.1269 18.3334 17.5 17.9603 17.5 17.5C17.5 17.0398 17.1269 16.6667 16.6667 16.6667C16.2064 16.6667 15.8333 17.0398 15.8333 17.5C15.8333 17.9603 16.2064 18.3334 16.6667 18.3334Z"
                                        stroke="black"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M0.833344 0.833313H4.16668L6.40001 11.9916C6.47621 12.3753 6.68493 12.7199 6.98963 12.9652C7.29433 13.2105 7.67559 13.3408 8.06668 13.3333H16.1667C16.5578 13.3408 16.939 13.2105 17.2437 12.9652C17.5484 12.7199 17.7571 12.3753 17.8333 11.9916L19.1667 4.99998H5.00001"
                                        stroke="black"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_5571_58128">
                                        <rect
                                          width="20"
                                          height="20"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  {this.state?.dashboardCount?.watchListCount >
                                  0 ? (
                                    <span class="cart-numbers">
                                      {
                                        this.state?.dashboardCount
                                          ?.watchListCount
                                      }
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </a>
                              }
                            </li>

                            <li
                              className={`${styles.hnlItem} hnl-item`}
                              style={{ marginLeft: "10px" }}
                            >
                              <a
                                href="javascript:void(0)"
                                className={` hnl-link my-account-text ${styles.myAccountText}`}
                                data-bs-toggle="modal"
                                data-bs-target="#profileCollapse"
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (this.props.myaccount) {
                                    this.setState({
                                      showDashboardSidebarMobile: true,
                                    });
                                  } else {
                                    if (
                                      typeof window !== "undefined" &&
                                      localStorage.getItem("token")
                                    ) {
                                      window.open(
                                        process.env
                                          .GATSBY_AVIATION_REDIRECT_URL +
                                          `my-account/dashboard`
                                      );
                                    } else {
                                      localStorage.setItem(
                                        "redirectUrl",
                                        process.env
                                          .GATSBY_AVIATION_REDIRECT_URL +
                                          window.location.pathname
                                      );
                                      window.open(
                                        process.env
                                          .GATSBY_AVIATION_REDIRECT_URL +
                                          `members/login`
                                      );
                                    }
                                  }
                                }}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                                    stroke="black"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                                {typeof window !== "undefined" &&
                                window.localStorage.getItem("token")
                                  ? ""
                                  : "Login"}
                              </a>
                            </li>
                            <li>
                              {typeof window !== "undefined" &&
                              window.localStorage.getItem("token") ? (
                                <a
                                  href={
                                    process.env.GATSBY_AVIATION_REDIRECT_URL +
                                    "members/post-listing"
                                  }
                                  className={`${styles.headerBtn}  header-btn d-none d-md-block ms-3`}
                                >
                                  <svg
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10.0002 4.16669V15.8334"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M4.16687 10H15.8335"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Post a Listing
                                </a>
                              ) : (
                                <a
                                  href={"javascript:void(0)"}
                                  className={`${styles.headerBtn} header-btn d-none d-md-block ms-3`}
                                  onClick={(e) => {
                                    localStorage.setItem(
                                      "redirectUrl",
                                      process.env.GATSBY_AVIATION_REDIRECT_URL +
                                        window.location.pathname
                                    );
                                    window.location.href =
                                      process.env.GATSBY_AVIATION_REDIRECT_URL +
                                      `members/login`;
                                  }}
                                >
                                  <sv
                                    viewBox="0 0 20 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M10.0002 4.16669V15.8334"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M4.16687 10H15.8335"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </sv>
                                  Post a Listing
                                </a>
                              )}
                            </li>
                          </>
                        ) : (
                          <li className={`${styles.hnlItem} hnl-item`}>
                            <a
                              href={
                                typeof window !== "undefined" &&
                                window.localStorage.getItem("token")
                                  ? process.env.GATSBY_AVIATION_REDIRECT_URL +
                                    `my-account/dashboard`
                                  : process.env.GATSBY_AVIATION_REDIRECT_URL +
                                    `members/login/`
                              }
                              className={` hnl-link my-account-text ${styles.myAccountText}`}
                              data-bs-toggle="modal"
                              data-bs-target="#profileCollapse"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              {typeof window !== "undefined" &&
                              window.localStorage.getItem("token")
                                ? "My Account"
                                : "Login"}
                            </a>
                          </li>
                        )}
                      </>
                    )}
                  </ul>
                  <div
                    className={`${styles.headerRight} header-right d-flex align-items-center flex-grow-1`}
                  >
                    <div className={` htc-nav  ms-auto d-none d-xl-block`}>
                      {typeof window !== "undefined" && (
                        <>
                          {localStorage.getItem("token") ? (
                            <ul
                              className={`${styles.htcNavList} htc-nav-list text-capitalize d-flex align-items-center`}
                            >
                              <li
                                className={`${styles.htcNavItem} htc-nav-item`}
                              >
                                <a
                                  href={
                                    process.env.GATSBY_AVIATION_REDIRECT_URL
                                  }
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#notificationCollapse"
                                >
                                  <svg
                                    className={`${styles.htcNavLink} htc-nav-link`}
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.5 7.49996L10 1.66663L17.5 7.49996V16.6666C17.5 17.1087 17.3244 17.5326 17.0118 17.8451C16.6993 18.1577 16.2754 18.3333 15.8333 18.3333H4.16667C3.72464 18.3333 3.30072 18.1577 2.98816 17.8451C2.67559 17.5326 2.5 17.1087 2.5 16.6666V7.49996Z"
                                      stroke="black"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M7.5 18.3333V10H12.5V18.3333"
                                      stroke="black"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Home
                                </a>
                              </li>

                              <li
                                className={`${styles.htcNavItem} htc-nav-item`}
                              >
                                <a
                                  href={
                                    process.env.GATSBY_AVIATION_REDIRECT_URL +
                                    "my-account/dashboard"
                                  }
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#profileCollapse"
                                >
                                  <svg
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0653 12.8512 14.2174 12.5 13.3334 12.5H6.66671C5.78265 12.5 4.93481 12.8512 4.30968 13.4763C3.68456 14.1014 3.33337 14.9493 3.33337 15.8333V17.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9.99996 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 9.99996 2.5C8.15901 2.5 6.66663 3.99238 6.66663 5.83333C6.66663 7.67428 8.15901 9.16667 9.99996 9.16667Z"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  My Account
                                </a>
                              </li>
                              <li
                                className={`${styles.htcNavItem} htc-nav-item`}
                              >
                                <a
                                  href="javascript:void(0)"
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  onClick={(es) => {
                                    es.preventDefault();
                                    this.onLogOut();
                                  }}
                                >
                                  <svg
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12.5 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H12.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.33337 14.1666L12.5 9.99998L8.33337 5.83331"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12.5 10H2.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Logout
                                </a>
                              </li>
                            </ul>
                          ) : (
                            <ul
                              className={`${styles.htcNavList} htc-nav-list text-capitalize d-flex align-items-center`}
                            >
                              <li
                                className={`${styles.htcNavItem} htc-nav-item`}
                              >
                                <a
                                  href={
                                    process.env.GATSBY_AVIATION_REDIRECT_URL
                                  }
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#notificationCollapse"
                                >
                                  <svg
                                    className={`${styles.htcNavLink} htc-nav-link`}
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M2.5 7.49996L10 1.66663L17.5 7.49996V16.6666C17.5 17.1087 17.3244 17.5326 17.0118 17.8451C16.6993 18.1577 16.2754 18.3333 15.8333 18.3333H4.16667C3.72464 18.3333 3.30072 18.1577 2.98816 17.8451C2.67559 17.5326 2.5 17.1087 2.5 16.6666V7.49996Z"
                                      stroke="black"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M7.5 18.3333V10H12.5V18.3333"
                                      stroke="black"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Home
                                </a>
                              </li>
                              <li
                                className={`${styles.htcNavItem} htc-nav-item`}
                              >
                                <a
                                  href={
                                    process.env.GATSBY_AVIATION_REDIRECT_URL +
                                    "members/register"
                                  }
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                  data-bs-toggle="modal"
                                  data-bs-target="#profileCollapse"
                                >
                                  <svg
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M16.6667 17.5V15.8333C16.6667 14.9493 16.3155 14.1014 15.6904 13.4763C15.0653 12.8512 14.2174 12.5 13.3334 12.5H6.66671C5.78265 12.5 4.93481 12.8512 4.30968 13.4763C3.68456 14.1014 3.33337 14.9493 3.33337 15.8333V17.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M9.99996 9.16667C11.8409 9.16667 13.3333 7.67428 13.3333 5.83333C13.3333 3.99238 11.8409 2.5 9.99996 2.5C8.15901 2.5 6.66663 3.99238 6.66663 5.83333C6.66663 7.67428 8.15901 9.16667 9.99996 9.16667Z"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Signup
                                </a>
                              </li>
                              <li
                                className={`${styles.htcNavItem} htc-nav-item`}
                              >
                                <a
                                  href={
                                    process.env.GATSBY_AVIATION_REDIRECT_URL +
                                    `members/login/`
                                  }
                                  className={`${styles.htcNavLink} htc-nav-link`}
                                >
                                  <svg
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12.5 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H12.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.33337 14.1666L12.5 9.99998L8.33337 5.83331"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M12.5 10H2.5"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                  Login
                                </a>
                              </li>
                            </ul>
                          )}
                        </>
                      )}
                    </div>
                    {/* <UpcomingDropDown allUpcomingBidDropDown={this.props.allUpcomingBidDropDown} /> */}

                    {typeof window !== "undefined" &&
                    window.localStorage.getItem("token") ? (
                      <a
                        href={
                          process.env.GATSBY_AVIATION_REDIRECT_URL +
                          "members/post-listing"
                        }
                        className={`${styles.headerBtn} header-btn d-none d-xl-block ms-auto`}
                      >
                        <svg
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.0002 4.16669V15.8334"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.16687 10H15.8335"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Post a Listing
                      </a>
                    ) : (
                      <a
                        href={
                          process.env.GATSBY_AVIATION_REDIRECT_URL +
                          "members/login/"
                        }
                        className={`${styles.headerBtn} header-btn d-none d-xl-block`}
                        onClick={(e) => {
                          localStorage.setItem(
                            "redirectUrl",
                            process.env.GATSBY_AVIATION_REDIRECT_URL +
                              window.location.pathname
                          );
                          window.location.href =
                            process.env.GATSBY_AVIATION_REDIRECT_URL +
                            `members/login`;
                        }}
                      >
                        <svg
                          viewBox="0 0 20 20"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.0002 4.16669V15.8334"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M4.16687 10H15.8335"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        Post a Listing
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </nav>
          </div>{" "}
        </header>
        <div
          class={`${styles.mobFilterBtnGroup} mob-filter-btn-group mob-filter-btn-group-new ${styles.mobFilterBtnGroupNew} d-md-none d-flex align-items-center`}
        >
          <a
            href="javascript:void(0)"
            className={`filter-btn d-flex align-items-center justify-content-center`}
            data-bs-toggle="modal"
            data-bs-target="#browseCollapse"
            onClick={this.toggleMobileFilter1}
          >
            <p>Browse</p>
          </a>
          {typeof window !== "undefined" &&
          window.localStorage.getItem("token") ? (
            <a
              href={
                process.env.GATSBY_AVIATION_REDIRECT_URL +
                "members/post-listing"
              }
              className={`${styles.postListing} post-listing d-flex align-items-center justify-content-center`}
            >
              + Post a Listing
            </a>
          ) : (
            <a
              href={"javascript:void(0)"}
              className={`${styles.postListing} post-listing d-flex align-items-center justify-content-center`}
              onClick={(e) => {
                localStorage.setItem(
                  "redirectUrl",
                  process.env.GATSBY_AVIATION_REDIRECT_URL +
                    window.location.pathname
                );
                window.location.href =
                  process.env.GATSBY_AVIATION_REDIRECT_URL + `members/login`;
              }}
            >
              + Post a Listing
            </a>
          )}
        </div>

        <MobileDropdown
          showModal={this.state.showMobileFilter}
          toggleModal={this.toggleMobileFilter}
          data={this.state.data}
        />
        <MobileDropdown1
          showModal={this.state.showMobileFilter1}
          toggleModal={this.toggleMobileFilter1}
          data={this.state.data}
        />
      </React.Fragment>
    );
  }
}

export default Header;
